(function(angular){
	'use strict';
	
	angular
		.module('autoInvestFeatureModule')
		.controller('AutoInvestFeatureController', [
			'$scope',
			'AUTO_INVEST_AMOUNTS',
			AutoInvestFeatureControllerFunction
		]);
	
	function AutoInvestFeatureControllerFunction(
		$scope,
		AUTO_INVEST_AMOUNTS
	){
		var autoInvestFeature = this;

		autoInvestFeature.updateGraph = function() {
			if(angular.isDefined(autoInvestFeature.amount.value) && autoInvestFeature.amount.value !== 'other') {
				$scope.$broadcast('futureEarningsChart:update', autoInvestFeature.amount.value, autoInvestFeature.frequency.value);
			}
		};

		$scope.$watch('autoInvestFeature.amount', function() {
			autoInvestFeature.updateGraph();
		});

		autoInvestFeature.$onInit = function() {
			autoInvestFeature.amountOptions = angular.copy(AUTO_INVEST_AMOUNTS);
			autoInvestFeature.frequencyOptions = [{
				label: 'Monthly',
				value: 6
			}, {
				label: 'Twice a Month',
				value: 21
			}];

			autoInvestFeature.amount = autoInvestFeature.amountOptions[1];
			autoInvestFeature.frequency = autoInvestFeature.frequencyOptions[0];
		};
	}
})(window.angular);